<template>
  <pagination
    v-model="paginationParams.page"
    :records="paginationParams.total"
    @paginate="myCallback"
  />
</template>

<script>
import Pagination from 'vue-pagination-2'
export default {
  components: {
    Pagination
  },
  props: ['paginationParams'],
  data() {
    return {
      page: 1
    }
  },
  methods: {
    myCallback() {}
  },
  mounted() {}
}
</script>
